import {isNotNilOrEmpty} from 'ramda-adjunct';

import {SellerResponseBody} from '@dms/api/core';

const GOOGLE_MAPS_SEARCH_URL = 'https://www.google.com/maps/search/?api=1&query=';

/**
 * Builds a Google Maps search link for the seller's address.
 *
 * Returns null when neither street nor city is known - a link built from the zip code
 * or the country alone would point to a random place instead of the seller.
 */
export function getSellerMapUrl(seller: SellerResponseBody): string | null {
  if (!isNotNilOrEmpty(seller.address) && !isNotNilOrEmpty(seller.city)) {
    return null;
  }

  const cityWithZip = [seller.zip, seller.city].filter(isNotNilOrEmpty).join(' ');
  const query = [seller.address, cityWithZip, seller.country?.translation]
    .filter(isNotNilOrEmpty)
    .join(', ');

  return `${GOOGLE_MAPS_SEARCH_URL}${encodeURIComponent(query)}`;
}
